// Default heights for different field types
export const DEFAULT_HEIGHTS = {
  TEXT_BOX: 18.33,
  PREFILLED_FIELD: 16,
  SIGNATURE: 33,
  CHECKBOX: 25,
  DATE_PICKER: 16,
};

// Default widths for different field types
export const DEFAULT_WIDTHS = {
  TEXT_BOX: 150,
  PREFILLED_FIELD: 183.33,
  SIGNATURE: 209,
  CHECKBOX: 25,
  DATE_PICKER: 54,
};

// Spacing constants
export const SPACING = {
  COMPONENT_PADDING: 6,
  CHECKBOX_PADDING: 2, // padding between checkbox and dotted border
};

// Optional: Define types for better type safety
export type DefaultHeightKey = keyof typeof DEFAULT_HEIGHTS;
export type DefaultWidthKey = keyof typeof DEFAULT_WIDTHS;
export type SpacingKey = keyof typeof SPACING;
